import { Component } from '@angular/core';

@Component({
  selector: 'app-compliance-outage-tile',
  templateUrl: './compliance-outage-tile.component.html',
  styleUrls: ['./compliance-tile.component.scss'],
})
export class ComplianceOutageTileComponent {
}
